module.exports = __webpack_public_path__ + "static/btob-e62b8fc790cfb802d7abc95f789a19b1.png";